import { links } from "../Components/Menu/Sidebar";

// Hiçbir menü sayfasına erişimi olmayan kullanıcının gideceği güvenli sayfa.
const FALLBACK_PATH = "/Anasayfa/Profil";

/**
 * Bir menü öğesi (link veya child) verilen kullanıcı bağlamında görünür mü?
 * Sidebar.js'teki filtreleme kurallarıyla birebir aynı olmalı.
 */
const isVisible = (item, ctx) => {
  if (item.adminOnly && ctx.role !== "admin") return false;
  if (item.hideForDealer && ctx.isDealer) return false;
  if (item.onlyDealer && !ctx.isDealer) return false;
  if (item.requirePanelAdmin && !ctx.firmPanelAdmin) return false;
  if (ctx.isWildcard) return true;
  if (item.anyOfPermission) return item.anyOfPermission.some((p) => ctx.has(p));
  if (item.permission) return ctx.has(item.permission);
  return true;
};

/**
 * Login sonrası kullanıcıyı yetkisine göre ilk erişilebilir sayfaya yönlendirir.
 * Sıra menüdeki (links) sırayı takip eder: Dashboard izni yoksa sıradaki ilk
 * yetkili sayfaya gider; hiçbirine yetkisi yoksa Profil'e düşer.
 *
 * @param {{role?:string, subRole?:string, permissions?:string[], firmPanelAdmin?:boolean}} user
 * @returns {string} yönlendirilecek yol
 */
export function resolveLandingPath(user) {
  const role = user?.role;
  const subRole = user?.subRole;
  const isDealer = role === "dealer";
  // Wildcard = admin veya DEPO management (usePermission ile aynı kural).
  const isWildcard =
    role === "admin" || (role === "storage" && subRole === "management");
  const permSet = new Set(user?.permissions || []);
  const ctx = {
    role,
    isDealer,
    isWildcard,
    firmPanelAdmin: user?.firmPanelAdmin,
    has: (p) => permSet.has(p),
  };

  for (const link of links) {
    if (!isVisible(link, ctx)) continue;
    if (link.path) return link.path;
    if (Array.isArray(link.childrens)) {
      const child = link.childrens.find((c) => isVisible(c, ctx) && c.path);
      if (child) return child.path;
    }
  }
  return FALLBACK_PATH;
}
